import scrollLock from 'scroll-lock';
import { getKeyboardFocusableElements } from '../utils';

export default class Menu {
	constructor() {

		this.isOpen = false;

		this.toggleButton = document.querySelector('[data-menu-toggle]');

		if(this.toggleButton) {
			this.toggleButton.addEventListener('click', () => {
				this.toggleMenu();
			});
		}

		this.menu = document.querySelector('[data-menu]');
		this.header = document.querySelector('[data-header]');

		if(!this.menu) {
			return;
		}

		this.keyboardFocusableElements = getKeyboardFocusableElements(this.header);

		this.firstFocusableEl = this.keyboardFocusableElements[0];
		this.lastFocusableEl = this.keyboardFocusableElements[this.keyboardFocusableElements.length-1];

		// Keyboard
		window.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				if (this.isOpen) {
					this.toggleMenu();
				}
			}

			if (e.key === 'Tab' || e.key === 9) {
				if (this.isOpen) {
					if (e.shiftKey) {
						/* shift + tab */ if (document.activeElement === this.firstFocusableEl) {
							this.lastFocusableEl.focus();
							e.preventDefault();
						}
					} /* tab */ else {
						if (document.activeElement === this.lastFocusableEl) {
							this.firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}
			}
		});
	}

	toggleMenu() {
		if(!this.isOpen) {
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.isOpen = true;
		this.menu.removeAttribute('inert');
		document.body.classList.add('body--menu-open');

		if(this.toggleButton) {
			this.toggleButton.setAttribute('aria-expanded', true);
		}
		if(this.keyboardFocusableElements) {
			this.keyboardFocusableElements[3].focus();
		}
		if(this.menu) {
			this.menu.setAttribute('aria-hidden', false);
		}
		scrollLock.disablePageScroll(this.menu);
	}

	close() {
		this.isOpen = false;
		this.menu.setAttribute('inert', '');
		document.body.classList.remove('body--menu-open');

		if(this.toggleButton) {
			this.toggleButton.setAttribute('aria-expanded', false);
			this.toggleButton.focus();
		}
		if(this.menu) {
			this.menu.setAttribute('aria-hidden', true);
		}

		scrollLock.enablePageScroll(this.menu);
	}
}
